import { ROLE_PERMISSIONS_BY_ROUTE } from 'shared/constants/router';

import type { RouteObject } from 'app/providers/RouterProvider';
import type { To } from 'react-router-dom';
import type { UserRole } from 'shared/types';

type Key = To | Pick<RouteObject, 'path'>;

export const isPermittedRoute = (role: UserRole, key?: Key) =>
  key &&
  typeof key === 'string' &&
  (ROLE_PERMISSIONS_BY_ROUTE[key]?.includes(role) ||
    !ROLE_PERMISSIONS_BY_ROUTE[key]);
